const AVATAR_COLORS = [
  '#6366f1',
  '#8b5cf6',
  '#ec4899',
  '#f43f5e',
  '#f97316',
  '#eab308',
  '#22c55e',
  '#14b8a6',
  '#0ea5e9',
  '#3b82f6',
];

function hashString(value) {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

/**
 * Cor e iniciais determinísticas de avatar.
 * Fonte única para todos os módulos — usada em Agenda, Kanban, Tarefas e filtros
 * para que o mesmo agente sempre apareça com a mesma cor (a cor real do usuário,
 * salva em users.color) quando não tem foto de perfil.
 */
export function useAvatarColor() {
  function avatarColor(entity) {
    if (typeof entity === 'object' && entity !== null) {
      if (entity.color) return entity.color;
      const name = entity.name ?? entity.label ?? '';
      return AVATAR_COLORS[hashString(name) % AVATAR_COLORS.length];
    }
    const name = entity ?? '';
    return AVATAR_COLORS[hashString(name) % AVATAR_COLORS.length];
  }

  function initials(name = '') {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return '';
    if (words.length === 1) return words[0][0].toUpperCase();
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }

  return { avatarColor, initials };
}
